import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonAction, ButtonType } from '../action-button';
import { ConfirmationDialogAfterClosedModel, ConfirmationDialogDataModel } from './models/confirmation-dialog.model';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'ui-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  confirmed$ = new BehaviorSubject<ConfirmationDialogAfterClosedModel>(null);
  cancelled$ = new BehaviorSubject<ConfirmationDialogAfterClosedModel>(null);
  buttonAction = ButtonAction;
  buttonType = ButtonType;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ConfirmationDialogDataModel,
  ) {}

  confirm(): void {
    this.confirmed$.next({
      dialogRef: this.dialogRef,
    });
  }

  closeDialog(): void {
    this.cancelled$.next({
      dialogRef: this.dialogRef,
    });
    this.dialogRef.close();
  }
}
